import React from 'react';
import {
  ChatBubbleLeftRightIcon,
  DevicePhoneMobileIcon,
  EnvelopeIcon,
  PhoneIcon,
  BookmarkIcon,
} from '@heroicons/react/24/outline';

const MANAGEMENT_TABS = [
  { id: 'all', label: 'Historial', icon: ChatBubbleLeftRightIcon },
  { id: 'whatsapp', label: 'WhatsApp', icon: DevicePhoneMobileIcon },
  { id: 'email', label: 'Email', icon: EnvelopeIcon },
  { id: 'call', label: 'Llamadas', icon: PhoneIcon },
  { id: 'sms', label: 'SMS', icon: ChatBubbleLeftRightIcon },
  { id: 'annotations', label: 'Anotaciones', icon: BookmarkIcon },
];

const ManagementTabs = ({ activeTab, onTabChange }) => {
  const handleTabClick = tabId => {
    if (activeTab !== tabId) {
      onTabChange(tabId);
    }
  };

  return (
    <div className='border-b border-slate-200'>
      <nav className='-mb-px flex space-x-4 overflow-x-auto mx-2' aria-label='Tabs'>
        {MANAGEMENT_TABS.map(tab => {
          const isActive = activeTab === tab.id;
          const IconComponent = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors focus:outline-none focus:ring-0 flex items-center gap-1.5 ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              }`}
            >
              <IconComponent className='w-4 h-4' />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default ManagementTabs;
